import { Link, useNavigate } from 'react-router-dom'
import PublicLayout from '../components/layout/PublicLayout'
import { generateKey } from '../utils/key'

const STEPS = [
  {
    n: '01',
    title: 'Create your key',
    body: 'Tap “Start free” and we generate a private address from a few random words — like /u/dot-prevent-room-grandfather. That URL is your log. Bookmark it or save it to your password manager. No email, no sign-up, nothing to verify.',
  },
  {
    n: '02',
    title: 'Log your moves',
    body: 'Record cardio, weights or general exercise from one quick form. Calories are estimated from METs and your weight; fields autocomplete from your own history, so the second time you log “Cross trainer” it already knows your usual.',
  },
  {
    n: '03',
    title: 'Log food by typing it',
    body: 'Type what you ate in plain language — “large flat white and a banana”. We send it to Claude, which itemises it into a full nutrition panel (calories, macros, sugars, fats, fibre, sodium and key micros). You confirm or tweak, then log. No barcode hunting, no giant database to search.',
  },
  {
    n: '04',
    title: 'See targets & trends',
    body: 'Add your height, age, sex, activity level and goal once, and we compute your BMI, BMR and TDEE (Mifflin–St Jeor) plus personalised nutrition targets from AU/NZ reference values. The analytics tabs chart calories in vs out, energy balance and intake vs target.',
  },
  {
    n: '05',
    title: 'Keep it safe',
    body: 'Optionally add a password lock (set it to lock on every visit or after inactivity). Add a backup email so you can recover your key — or reset a forgotten password — by email. Your last few versions are backed up automatically, and you can export everything as JSON anytime.',
  },
]

export default function HowItWorks() {
  const navigate = useNavigate()
  return (
    <PublicLayout>
      <div className="mx-auto max-w-3xl px-6 py-16">
        <p className="font-display text-sm font-bold uppercase tracking-widest text-[var(--accent-teal)]">How it works</p>
        <h1 className="font-display mt-2 text-4xl font-extrabold leading-tight md:text-5xl">
          From zero to logging in seconds.
        </h1>
        <p className="mt-6 text-lg leading-relaxed text-[var(--text-secondary)]">
          A quick setup, then you're logging. Here's the whole thing, start to finish.
        </p>

        <ol className="mt-12 space-y-6">
          {STEPS.map((s) => (
            <li key={s.n} className="flex gap-5 rounded-xl border border-[var(--border)] bg-[var(--bg-secondary)]/60 p-6 backdrop-blur-sm">
              <div className="font-display shrink-0 text-3xl font-extrabold text-[var(--accent-teal)]">{s.n}</div>
              <div>
                <h2 className="font-display text-xl font-bold">{s.title}</h2>
                <p className="mt-2 leading-relaxed text-[var(--text-secondary)]">{s.body}</p>
              </div>
            </li>
          ))}
        </ol>

        <div className="mt-12 flex flex-wrap items-center gap-3">
          <button onClick={() => navigate(`/u/${generateKey()}?welcome=1`)} className="btn btn-primary px-6 py-3 font-semibold">
            Start your log — free
          </button>
          <Link to="/features" className="btn btn-secondary">See all features</Link>
        </div>
      </div>
    </PublicLayout>
  )
}
